exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.close-reason-dialog .el-dialog__body{text-align:center\n}\n", "", {"version":3,"sources":["/data/jenkins/workspace/shop/src/components/bigAftersale/close-reason-dialog.vue"],"names":[],"mappings":";AAkDA,sCAEI,iBAAkB;CACnB","file":"close-reason-dialog.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.close-reason-dialog{\n  .el-dialog__body {\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69c11e40","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/bigAftersale/close-reason-dialog.vue
// module id = SqTU
// module chunks = 2